import { devtools, persist } from 'zustand/middleware'
import create from 'zustand'
import PackageModel, { PackagesMap } from '@geartrack/shared-lib/dist/PackageModel'
import { immer } from 'zustand/middleware/immer'
import { notifyAndLog } from '../libraries/utils'

type IPackagesState = {
  packages: PackagesMap
}

const state = (): IPackagesState => ({
  packages: {},
})

export const usePackageStoreNew = create<IPackagesState>()(
  persist(
    immer(
      devtools(state, {
        name: 'packages',
      })
    ),
    {
      // middlewares
      name: 'packages',
      version: 2,
      getStorage: () => localStorage,
      serialize: state => {
        if (state.state.packages) {
          const serialized = {}
          for (let packagesKey in state.state.packages) {
            // @ts-ignore
            serialized[packagesKey] = state.state.packages[packagesKey].serializeToPlainObject()
          }
          state.state.packages = serialized
        }

        return JSON.stringify(state)
      },
      deserialize: str => {
        const state = JSON.parse(str)

        if (state.state.packages) {
          for (let key in state.state.packages) {
            state.state.packages[key] = PackageModel.fromPlainObject(state.state.packages[key])
          }
        }

        return state
      },
      migrate: (persistedState, version) => {
        // Migration to a map of PackageModel type
        // Migration to firebase
        if (version < 2) {
          const map: PackagesMap = {}
          // @ts-ignore
          const currentPackages: any[] = persistedState.packages

          for (let oldPackage of currentPackages) {
            try {
              const newKey = oldPackage.computedKey?.replace('local_', '')
              map[newKey] = new PackageModel(
                newKey,
                oldPackage.trackingId,
                oldPackage.createdAt,
                oldPackage.description,
                oldPackage.extraData,
                oldPackage.collapsed
              )
            } catch (e) {
              notifyAndLog(e)
            }
          }

          return { packages: map }
        }

        // fallback if the version is wrong
        return {
          packages: {},
        }
      },
    }
  )
)
